import React from 'react'
import { useAuthStore } from '../store/useAuthStore'

export default function TopHeader({ pageName }) {
  let { authUser } = useAuthStore()
  return (
    <div id="header" className="bg-white border-b border-neutral-200 flex items-center justify-between h-16 px-6">
      <div className="flex items-center">
        <h1 className="text-xl text-neutral-800">{pageName}</h1>
      </div>

      <div className="flex items-center">
        <a
          href="https://5star-sooty.vercel.app"
          target="_blank"
          rel="noopener noreferrer"
          className="text-xl text-neutral-800 underline"
        >
          CLICK TO OPEN USER HOMEPAGE
        </a>
      </div>

      <div className="flex items-center flex-col space-x-2">
        <img src={authUser?.avatar} alt="User Avatar" className="w-8 h-8 rounded-full" />
        <span className="text-sm">{authUser?.fullName?.toUpperCase()}</span>
      </div>
    </div>
  )
}
